import { useFlagValue } from 'src/flagging/hooks';
import { useMember } from '.';
export var useIsInternalMember = function (memberId) {
    var _a, _b, _c;
    var data = useMember(memberId !== null && memberId !== void 0 ? memberId : '').data;
    var customerIds = useFlagValue('SPRING_HEALTH_CUSTOMER_IDS');
    return !!(data && customerIds.includes((_c = (_b = (_a = data.cohort) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : ''));
};
